export default __webpack_public_path__ + "static/111-68c8c88b1ccc3142a83eedb976058ff2.jpg";